import React, { useState } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import './ConsentStepper.css';
const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: '100%',
    },
    step: {
      "&$completed": {
        color: "green"
      },
      "&$active": {
        color: "#555"
      },
    },
    alternativeLabel: {},
    active: {},
    completed: {},
    labelContainer: {
      "&$alternativeLabel": {
        marginTop: 0
      },
    },
  }),
);

function getSteps() {
  return [
    <p style={{ color: '#555', textAlign: 'left', padding: '0' }}>Photo Verification</p>,
    <p style={{ color: '#555', textAlign: 'left', padding: '0' }}> Policy Related Questions</p>,
    <p style={{ color: '#555', textAlign: 'left' }}>Video Consent Recording</p>,
    <p style={{ color: '#555', textAlign: 'left', padding: '0' }}>OTP verification</p>
  ];
}
const ConsentStepper = (props) => {
  const classes = useStyles();
  const steps = getSteps();
  const [activeStep] = useState(props.currentStep);
  return (
    <div className={classes.root}>
      <Stepper activeStep={activeStep} orientation={props.orientation}>
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel
              StepIconProps={{
                classes: {
                  root: classes.step,
                  completed: classes.completed,
                  active: classes.active,
                  disabled: classes.disabled
                }
              }}
            >{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
}

export default ConsentStepper;